import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../services/authAPI';
import NotificationBell from '../notifications/NotificationBell';

const Header = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
  try {
    // Step 1: Call backend logout API to blacklist token
    await authAPI.logout();
    
    // Step 2: Clear frontend auth state
    logout();
    
    // Step 3: Navigate to home
    navigate('/');
    
    console.log('✅ Logout successful');
  } catch (error) {
    console.error('❌ Logout error:', error);
    
    // Even if API fails, still clear frontend state
    logout();
    navigate('/');
  }
};


  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="logo">
            <span className="logo-text">Job Portal</span>
          </Link>
        </div>

        <div className="header-right">
          <NotificationBell />
          {isAuthenticated ? (
            <div className="user-menu">
              <span className="user-name">Welcome, {user?.firstName || user?.email}</span>
              <div className="user-dropdown">
                <Link to="/dashboard" className="dropdown-item">Dashboard</Link>
                <Link to="/profile" className="dropdown-item">Profile</Link>
                <button onClick={handleLogout} className="dropdown-item logout-btn">
                  Sign Out
                </button>
              </div>
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="btn btn-outline">Sign In</Link>
              <Link to="/register" className="btn btn-primary">Join Now</Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
